import * as ActionType from '../../constants/actionType';
import {ProtocolEditorViewMode} from '../../constants/dataEnum';

const initialState = {
  selectedLabwareID: 0,
  currentTipVolume: 0,
  selectedTipChannel: '',
  customTipCount: null,
  selectedMenu: ProtocolEditorViewMode.SIMPLE_TRANSFER,
  serialDilutionStep: 0,
  serialDilutionEditStep: false,
  serialDilutionPrevStep: null,
  serialDilutionSetToAllSample: false,
  openSdPreview: false,
  broadcastTaskEditStep: null,
  poolingTaskStep: null,
  poolingTaskEditStep: null,
  nextTipVolumeState: 0,
  prevTipVolumeState: 0,
  normalizationTaskEditStep: null,
  isEditMixing: false,
  volumeModalOpen: false,
  ADModalShown: false,
  copiedPipettingParameter: {},
  simpleTransferEditedType: null,
  autosave: true,
  isPendingSaveExist: false,
  tipsWasteToCaddy: false,
};

export default function protocolEditorStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SET_SELECTED_LABWAREID:
      return {...state, selectedLabwareID: action.id};
    case ActionType.SET_CURRENT_TIP_VOLUME:
      return {...state, currentTipVolume: action.volume};
    case ActionType.SET_SELECTED_TIP_CHANNEL:
      return {...state, selectedTipChannel: action.tipChannel};
    case ActionType.SET_CUSTOM_TIP_COUNT:
      return {...state, customTipCount: action.data};
    case ActionType.SET_SELECTED_MENU:
      return {...state, selectedMenu: action.data};
    case ActionType.SET_SERIAL_DILUTION_STEP:
      return {...state, serialDilutionStep: action.data};
    case ActionType.SET_SERIAL_DILUTION_EDIT_STEP:
      return {...state, serialDilutionEditStep: action.data};
    case ActionType.SET_SERIAL_DILUTION_SET_ALL_SAMPLE:
      return {...state, serialDilutionSetToAllSample: action.data};
    case ActionType.SET_SERIAL_DILUTION_PREV_STEP:
      return {...state, serialDilutionPrevStep: action.data};
    case ActionType.SET_OPEN_SD_PREVIEW:
      return {...state, openSdPreview: action.data};
    case ActionType.SET_BROADCAST_TASK_EDIT_STEP:
      return {...state, broadcastTaskEditStep: action.data};
    case ActionType.RESET_PROTOCOL_EDITOR_STATE:
      return initialState;
    case ActionType.RESTORE_PROTOCOL_EDITOR_STATE:
      if (!('prevTipVolumeState' in action.state)) {
        action.state.prevTipVolumeState = 0;
      }
      if (!('nextTipVolumeState' in action.state)) {
        action.state.nextTipVolumeState = 0;
      }
      return action.state;
    case ActionType.SET_POOLING_TASK_STEP:
      return {...state, poolingTaskStep: action.data};
    case ActionType.SET_POOLING_TASK_EDIT_STEP:
      return {...state, poolingTaskEditStep: action.data};
    case ActionType.SET_CURRENT_TIP_VOLUME_NEXT_STATE:
      return {...state, nextTipVolumeState: action.data};
    case ActionType.SET_CURRENT_TIP_VOLUME_PREV_STATE:
      return {...state, prevTipVolumeState: action.data};
    case ActionType.SET_NORMALIZATION_TASK_EDIT_STEP:
      return {...state, normalizationTaskEditStep: action.data};
    case ActionType.SET_IS_EDIT_MIXING:
      return {...state, isEditMixing: action.data};
    case ActionType.SET_VOLUME_MODAL_OPEN:
      return {...state, volumeModalOpen: action.data};
    case ActionType.SET_ASPIRATE_DISPENSE_MODAL_SHOWN:
      return {...state, ADModalShown: action.data};
    case ActionType.SET_COPIED_PIPETTING_PARAMETER:
      return {...state, copiedPipettingParameter: action.data};
    case ActionType.RESET_COPIED_PIPETTING_PARAMETER:
      return {...state, copiedPipettingParameter: {}};
    case ActionType.SET_SIMPLE_TRANSFER_EDITED_TYPE:
      return {...state, simpleTransferEditedType: action.data};
    case ActionType.ENABLE_AUTO_SAVE:
      return {...state, autosave: true};
    case ActionType.DISABLE_AUTO_SAVE:
      return {...state, autosave: false};
    case ActionType.SET_PENDING_SAVE_EXIST:
      return {...state, isPendingSaveExist: action.isExist};
    default:
      return state;
  }
}
